import { useStore } from "@/context/StoreContext";

/**
 * Brand logo. `on="dark"` renders the white variant for aubergine surfaces;
 * `on="light"` renders the colour variant for ivory/white. Until the owner
 * uploads the real artwork in Brand Settings, a clean text wordmark is shown.
 */
export default function Logo({ on = "dark", className = "h-9", withTagline = true, testid = "brand-logo" }) {
  const { config } = useStore();
  const brand = config?.brand || {};
  const src = on === "dark"
    ? (brand.logo_dark || "")
    : (brand.logo_light || config?.logo_url || "");
  if (src) {
    return <img src={src} alt={config?.store_name || "Siyaara"} className={`${className} object-contain`} data-testid={testid} />;
  }
  return (
    <span className={`inline-flex flex-col leading-none ${on === "dark" ? "text-ivory" : "text-brand"}`} data-testid={testid}>
      <span className="font-heading font-semibold text-2xl tracking-[0.08em]">
        {config?.store_name || "Siyaara"}
      </span>
      {withTagline && (
        <span className={`text-[9px] font-sans font-medium uppercase tracking-[0.3em] mt-0.5 ${on === "dark" ? "text-gold" : "text-ink-2"}`}>
          Jewels of Love
        </span>
      )}
    </span>
  );
}
